import React, {useMemo} from 'react';
import useScreenSize from "../../../helpers/hooks/useScreenSize";
import {FlexColumnSection} from "../../../styles/globalStyles";
import HowItWorks from "./HowItWorks";
import SummaryCard from "../../../components/SummaryCard";
import {t} from 'i18next';
import {useSelector} from 'react-redux';
import {
    getRequestDateLabel,
    getRequestTimeRangeLabel,
    getWaitlistOfferLabels,
    WAITLIST_DONT_WANT_ACTIONS
} from "./WaitlistHelpers";
import {membershipTypes} from "@arboxappv4/shared/src/helpers/constants";
import {handlePricingWithCurrency} from "../../../helpers/functions";

const OfferAnswerSummary = (props) => {
    const { actionType, flowRes } = props;
    const offer = useSelector(state => state.kiosk.appointmentWaitlistOffer);
    const selectedLocation = useSelector(state => state.kiosk.selectedLocation);
    const {isMobile} = useScreenSize();

    const currencySymbol = useMemo(() => selectedLocation?.currency_symbol ?? '', [selectedLocation]);

    const getSummaryRows = () => {
        switch (actionType) {
            case WAITLIST_DONT_WANT_ACTIONS.SKIP:
                const waitlistInfo = flowRes?.waitlist
                let dates = getRequestDateLabel(waitlistInfo)
                let times = getRequestTimeRangeLabel(waitlistInfo, true)
                return [
                    {label: t('appointment-waitlist-summary-service'), value: waitlistInfo?.box_category_name},
                    {label: t('appointment-waitlist-summary-coach'), value: waitlistInfo?.coach_ub_id ? waitlistInfo?.coach_name : t('appointment-waitlist-any-coach')},
                    {label: t('appointment-waitlist-summary-date'), value: dates},
                    {label: t('appointment-waitlist-summary-time'), value: times},
                ];
            case WAITLIST_DONT_WANT_ACTIONS.REMOVE:
            case 'book':
                const {serviceName, coach, dateLabel, timeLabel} = getWaitlistOfferLabels(offer)
                let rows = [
                    {label: t('appointment-waitlist-summary-service'), value: serviceName || '—'},
                    {label: t('appointment-waitlist-summary-coach'), value: coach?.full_name || '—'},
                    {label: t('appointment-waitlist-summary-date'), value: dateLabel || '—'},
                    {label: t('appointment-waitlist-summary-time'), value: timeLabel || '—'},
                ];
                if(actionType === 'book') {
                    const selectedMembership = flowRes?.values?.selectedMembership
                    let selectedPaymentLabel = ''
                    if (selectedMembership?.payForSlot) selectedPaymentLabel = handlePricingWithCurrency(selectedMembership?.price, currencySymbol)
                    if (selectedMembership?.mt_type === membershipTypes.PLAN) selectedPaymentLabel = t('waitlist-plan-selected-summary-label')
                    if (selectedMembership?.mt_type === membershipTypes.PUNCH_CARD) selectedPaymentLabel = t('waitlist-punch-selected-summary-label')
                    rows.push({label: t('appointment-waitlist-offer-summary-payment'), value: selectedPaymentLabel})
                }
                return rows
            default:
                return []
        }
    }

    return (
        <FlexColumnSection gap={'16px'} flex={'unset'} style={{width: isMobile ? '100%' : '520px', margin: '10px 0'}}>
            <SummaryCard title={t(actionType === WAITLIST_DONT_WANT_ACTIONS.REMOVE ? `appointment-waitlist-offer-${actionType}-summary-title` : 'appointment-waitlist-summary-title')} rows={getSummaryRows()}/>
            {actionType === WAITLIST_DONT_WANT_ACTIONS.SKIP && <HowItWorks/>}
        </FlexColumnSection>
    );
};

export default OfferAnswerSummary;